import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initOpenReplay } from './app/openreplay';
import { initSentry } from './app/sentry';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Before bootstrap, so errors raised while the app starts are reported too.
initSentry();
// Session recording (lazy, after load + idle; never blocks or breaks the page).
initOpenReplay();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
